<template>
  <div class="link-setting">
    <div class="top">
      <div class="flex-item">
        <b>云仓资料</b>
      </div>
    </div>
    <template v-if="isShow">
      <div v-if="!info.storeDisable" class="content empty">
        <img :src="require('@/assets/empty_shop.png')" class="empty-img" />
        <template v-if="userInfo.adminFlag">
          <div class="desc">暂未开通云仓，开通云仓后可在小紫平台展示所需要销售的商品</div>
          <el-button @click="handleOpenMarket" size="small" type="primary">开通店铺</el-button>
        </template>
        <div v-else class="desc">暂未开通云仓，请联系管理员进行开通，开通云仓后可以在小紫平台展示所需销售的商品</div>
      </div>
      <div v-else class="content">
        <template v-if="userInfo.isPersonal">
          <el-descriptions :colon="false" :column="2" size="medium">
            <el-descriptions-item label="云仓Logo" :span="2">
              <el-image
                v-for="(url, i) in [info.storeLogo]"
                :key="i"
                :src="url"
                :preview-src-list="[info.storeLogo]"
                style="width: 88px; height: 88px;">
              </el-image>
            </el-descriptions-item>
            <el-descriptions-item label="云仓名称">
              {{ info.storeName || '--' }}
              <span class="market-type">个人</span>
            </el-descriptions-item>
            <el-descriptions-item label="开通时间">{{ info.storeDisable === 'OPEN' ? formatDate(info.auditTime) : '未开通' }}</el-descriptions-item>
            <el-descriptions-item label="云仓简介" :span="2">{{ info.storeDesc || '--' }}</el-descriptions-item>
            <el-descriptions-item label="联系人姓名">{{ info.linkName || '--' }}</el-descriptions-item>
            <el-descriptions-item label="联系人电话">{{ info.linkPhone || '--' }}</el-descriptions-item>
            <el-descriptions-item label="仓库地址">{{ info.salesConsigneeDetail ? `${info.salesConsigneeAddressPath}${info.salesConsigneeDetail}` : '--' }}</el-descriptions-item>
            <el-descriptions-item label="电子邮箱">{{ info.linkEmail || '--' }}</el-descriptions-item>
            <el-descriptions-item label="银行名称">{{ info.settlementBankAccountName || '--' }}</el-descriptions-item>
            <el-descriptions-item label="银行账户">{{ info.settlementBankAccountNum || '--' }}</el-descriptions-item>
          </el-descriptions>
        </template>
        <template v-else>
          <el-descriptions :colon="false" :column="2" size="medium">
            <el-descriptions-item label="云仓Logo" :span="2">
              <el-image
                v-for="(url, i) in [info.storeLogo]"
                :key="i"
                :src="url"
                :preview-src-list="[info.storeLogo]"
                style="width: 88px; height: 88px;">
              </el-image>
            </el-descriptions-item>
            <el-descriptions-item label="云仓名称">
              {{ info.storeName || '--' }}
              <span class="market-type">企业</span>
            </el-descriptions-item>
            <el-descriptions-item label="开通时间">{{ info.storeDisable === 'OPEN' ? formatDate(info.auditTime) : '未开通' }}</el-descriptions-item>
            <el-descriptions-item label="云仓简介" :span="2">{{ info.storeDesc || '--' }}</el-descriptions-item>
            <el-descriptions-item label="企业名称">{{ info.companyName || '--' }}</el-descriptions-item>
            <el-descriptions-item label="统一社会信用代码">{{ info.licenseNum || '--' }}</el-descriptions-item>
            <el-descriptions-item label="注册资金">{{ info.registeredCapital ? info.registeredCapital+'万元' : '--' }}</el-descriptions-item>
            <el-descriptions-item label="人员规模">{{ info.employeeNum ? info.employeeNum+'人' : '--' }}</el-descriptions-item>
            <el-descriptions-item label="经营范围" :span="2">{{ info.scope || '--' }}</el-descriptions-item>
            <el-descriptions-item label="公司地址">{{ `${info.companyAddressPath || ''}${info.companyAddress || ''}` || '--' }}</el-descriptions-item>
            <el-descriptions-item label="仓库地址">{{ info.salesConsigneeDetail ? `${info.salesConsigneeAddressPath}${info.salesConsigneeDetail}` : '--' }}</el-descriptions-item>
            <el-descriptions-item label="公司电话">{{ info.companyPhone || '--' }}</el-descriptions-item>
            <el-descriptions-item label="联系人姓名">{{ info.linkName || '--' }}</el-descriptions-item>
            <el-descriptions-item label="联系人电话">{{ info.linkPhone || '--' }}</el-descriptions-item>
            <el-descriptions-item label="电子邮箱">{{ info.companyEmail || '--' }}</el-descriptions-item>
            <el-descriptions-item label="银行名称">{{ info.settlementBankAccountName || '--' }}</el-descriptions-item>
            <el-descriptions-item label="银行账户">{{ info.settlementBankAccountNum || '--' }}</el-descriptions-item>
            <el-descriptions-item label="营业执照">
              <template v-if="info.licencePhoto.length">
                <el-image
                  v-for="(url, i) in info.licencePhoto"
                  :key="'licence-'+i"
                  :src="url"
                  :preview-src-list="info.licencePhoto"
                  style="width: 88px; height: 88px;">
                </el-image>
              </template>
              <div v-else>--</div>
            </el-descriptions-item>
          </el-descriptions>
        </template>
      </div>
    </template>

    <OpenMarketDialog ref="openMarketRef" :id="info.id" @refresh="init" />
  </div>
</template>
<script>
import * as Moment from 'dayjs';
import { companyDetail } from '@/api/company';
import { getMarketStoreByLicenseNum, getMarketStoreByLinkPhone, tenantDetail } from '@/api/shop';
import OpenMarketDialog from '@/views/Shop/components/openMarketDialog.vue';

export default {
  data () {
    return {
      isShow: false,
      userInfo: JSON.parse(this.$local.get('userInfo')) || {},
      isPersonal: true,
      companyInfo: {},
      info: {
        phone: '',
        imageList: [],
      },
    };
  },
  components: {
    OpenMarketDialog,
  },
  methods: {
    formatDate (text) {
      return text ? Moment(text).format('YYYY-MM-DD HH:mm:ss') : '--';
    },
    async handleOpenMarket () {
      let msg = {
        confirmButtonText: '我知道了',
        text: '',
        type: null,
      };
      const { body } = await tenantDetail({
        id: this.userInfo.tenantId,
        findActivateServiceFlag: true,
      });
      if (body.activateService && body.activateService.includes('小紫VIS')) {
        msg.text = '尊敬的用户：VIS用户暂时无法开通云仓。针对VIS用户，平台后续将推出【商城店铺】专属服务，届时敬请关注。如有疑问请联系021-52813076';
      } else if (this.userInfo.authenticationStatus === '1' && !this.companyInfo.authenticationAuditStatus) {
        if (this.userInfo.isPersonal) {
          msg.text = '请先至平台小程序完成小紫平台个人认证，认证审核通过后才能开通云仓。';
        } else {
          msg.type = 'auth';
          msg.confirmButtonText = '去认证';
          msg.text = '请先完成小紫平台企业认证，认证审核通过后才能开通云仓。';
        }
      } else if (this.userInfo.authenticationStatus === '1' && this.companyInfo.authenticationAuditStatus === '3') {
        if (this.userInfo.isPersonal) {
          msg.text = '小紫平台个人认证审核失败，请至平台小程序重新认证，认证审核通过后才能开通云仓。';
        } else {
          msg.type = 'auth';
          msg.confirmButtonText = '重新认证';
          msg.text = '小紫平台企业认证审核失败，请重新认证！认证审核通过后才能开通云仓。';
        }
      } else if (this.companyInfo.authenticationAuditStatus === '1' && this.userInfo.authenticationStatus === '2') {
        msg.text = `小紫平台${this.userInfo.isPersonal ? '个人' : '企业'}认证正在审核中，审核通过后才能开通云仓。`;
      }
      if (msg.text) {
        const h = this.$createElement;
        this.$msgbox({
          title: '',
          showCancelButton: true,
          showClose: true,
          cancelButtonText: '取消',
          confirmButtonText: msg.confirmButtonText,
          message: h('div', { style: 'padding: 0 20px;' }, [
            h('i', { class: 'el-icon-warning', style: 'color:#FAB007; font-size: 17px;margin-right: 10px' }),
            h('span', { style: 'font-size: 16px; font-weight: bold; color: #1F2733;' }, '开通云仓'),
            h('p', { style: 'padding: 5px 10px 5px 30px; font-weight: 400; font-size: 14px; color: #1F2733;' }, msg.text),
          ]),
          beforeClose: (action, instance, done) => {
            if (action === 'confirm') {
              if (msg.type === 'auth') {
                this.$router.push('/systemSetting/corporate/certification');
              }
              done();
            } else {
              done();
            }
          },
        });
        return;
      }
      this.$refs.openMarketRef.dialogVisible = true;
    },
    async init () {
      const { body } = await companyDetail({ id: this.userInfo.tenantId });
      this.companyInfo = body || {};
      if (this.userInfo.authenticationStatus === '3') { // 已认证
        if (!this.userInfo.isPersonal) {
          const certCode = this.companyInfo.certCode || this.userInfo.certCode;
          if (certCode) {
            const { body } = await getMarketStoreByLicenseNum({ licenseNum: certCode });
            const storeInfo = body || {};
            this.info = {
              ...storeInfo,
              storeType: storeInfo.storeType || '2',
              licencePhoto: [],
              companyAddressPath: storeInfo.companyAddressPath ? storeInfo.companyAddressPath.replace(/,/g, '') : '',
            };
            this.logoLists = [ { url: storeInfo.storeLogo, name: 'logo' } ];
            (storeInfo.licencePhoto || '').split(',').map(url => {
              this.info.licencePhoto.push(url);
            });
          } else {
            this.$message.warning('企业营业执照号不存在！');
          }
        }
        if (this.userInfo.isPersonal) {
          const { body } = await getMarketStoreByLinkPhone({ linkPhone: this.userInfo.phoneNumber });
          this.info = body || {};
        }
      }

      this.isShow = true;
    },
  },
  created () {
    this.init();
  },
};
</script>
<style lang="scss" scoped>
.link-setting {
  font-size: 14px;
  color: #1F2733;

  .flex-item {
    display: inline-flex;
    align-items: center;
  }
  .top {
    display: flex;
    justify-content: space-between;
    padding: 10px;
    border-bottom: 1px solid #eeeeee;
  }

  .content {
    padding: 20px;
    /deep/ .el-descriptions-item__label {
      color: #929AA6;
    }

    .market-type {
      display: inline-block;
      background: #E2F3FE;
      border-radius: 4px;
      margin: 0 15px;
      padding: 0 6px;
      font-weight: 400;
      font-size: 12px;
      color: #237FFA;
    }
  }

  .empty {
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    height: calc(100vh - 122px - 70px);

    .empty-img {
      width: 140px;
      height: 140px;
    }
    .desc {
      padding-bottom: 20px;
      font-weight: 400;
      font-size: 16px;
      color: #1F2733;
      text-align: center;
    }
  }
}
</style>
